import React from "react";

export default function LegalLayout({ title, subtitle, lastUpdated, sections }) {
  return (
    <div style={{
      background: "#f8fafc",
      minHeight: "100vh",
      paddingTop: 120,
      paddingBottom: 80,
      fontFamily: "'Inter', 'Sarabun', 'Prompt', sans-serif",
    }}>
      <div style={{ maxWidth: 880, margin: "0 auto", padding: "0 24px" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <h1 style={{
            fontSize: "clamp(2rem, 4vw, 3rem)",
            fontWeight: 900,
            color: "#0b1220",
            marginBottom: 12,
            letterSpacing: "-0.01em",
          }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{
              fontSize: "1.05rem",
              color: "#64748b",
              marginBottom: 12,
            }}>
              {subtitle}
            </p>
          )}
          {lastUpdated && (
            <p style={{
              fontSize: "0.9rem",
              color: "#94a3b8",
              fontStyle: "italic",
            }}>
              {lastUpdated}
            </p>
          )}
          <div style={{
            width: 80,
            height: 4,
            background: "#d4af37",
            margin: "20px auto 0",
            borderRadius: 2,
          }} />
        </div>

        {/* Sections */}
        <div style={{
          background: "#fff",
          borderRadius: 20,
          padding: "48px 40px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          border: "1px solid rgba(0,0,0,0.05)",
        }}>
          {sections.map((sec, idx) => (
            <section key={idx} style={{ marginBottom: 32 }}>
              <h2 style={{
                fontSize: "1.25rem",
                fontWeight: 700,
                color: "#0b1220",
                marginBottom: 12,
              }}>
                {sec.h}
              </h2>
              <p style={{
                fontSize: "1rem",
                lineHeight: 1.8,
                color: "#334155",
                margin: 0,
              }}>
                {sec.p}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
